import React, { useState } from 'react';
import { MapPinIcon, ArrowRightIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
export function LoginPage({
  navigateTo
}: {
  navigateTo: (page: string) => void;
}) {
  const {
    t
  } = useLanguage();
  const [step, setStep] = useState(1);
  const [identifier, setIdentifier] = useState('');
  const [otp, setOtp] = useState('');
  const handleGetOtp = (e: React.FormEvent) => {
    e.preventDefault();
    if (identifier) setStep(2);
  };
  const handleLogin = (e: React.FormEvent) => {
    e.preventDefault();
    if (otp) navigateTo('dashboard');
  };
  return <div className="min-h-screen bg-[#F8FAFB] flex flex-col justify-center py-12 sm:px-6 lg:px-8" data-id="element-903">
      <div className="sm:mx-auto sm:w-full sm:max-w-md" data-id="element-904">
        <div className="flex justify-center" data-id="element-905">
          <div className="w-16 h-16 bg-[#006A4E] rounded-2xl flex items-center justify-center shadow-lg" data-id="element-906">
            <MapPinIcon className="w-8 h-8 text-white" data-id="element-907" />
          </div>
        </div>
        <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900" data-id="element-908">
          {t('appTitleShort')}
        </h2>
        <p className="mt-2 text-center text-sm text-gray-600" data-id="element-909">
          Government of the People's Republic of Bangladesh
        </p>
      </div>

      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md" data-id="element-910">
        <div className="bg-white py-8 px-4 shadow-xl shadow-gray-200/50 sm:rounded-xl sm:px-10 border border-gray-100" data-id="element-911">
          {step === 1 ? <form className="space-y-6" onSubmit={handleGetOtp} data-id="element-912">
              <div data-id="element-913">
                <label htmlFor="identifier" className="block text-sm font-medium text-gray-700" data-id="element-914">
                  {t('enterMobileNID')}
                </label>
                <div className="mt-2" data-id="element-915">
                  <input id="identifier" name="identifier" type="text" required value={identifier} onChange={e => setIdentifier(e.target.value)} className="appearance-none block w-full px-4 py-3 border border-gray-300 rounded-lg shadow-sm placeholder-gray-400 focus:outline-none focus:ring-[#006A4E] focus:border-[#006A4E] sm:text-sm" placeholder="e.g. 01712345678 or 1987654321098" data-id="element-916" />
                </div>
              </div>

              <div data-id="element-917">
                <button type="submit" className="w-full flex justify-center items-center py-3 px-4 border border-transparent rounded-lg shadow-sm text-sm font-medium text-white bg-[#006A4E] hover:bg-[#004D3A] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#006A4E] transition-colors" data-id="element-918">
                  {t('getOTP')}
                  <ArrowRightIcon className="ml-2 w-4 h-4" data-id="element-919" />
                </button>
              </div>
            </form> : <form className="space-y-6" onSubmit={handleLogin} data-id="element-920">
              <div data-id="element-921">
                <label htmlFor="otp" className="block text-sm font-medium text-gray-700" data-id="element-922">
                  {t('enterOTP')}
                </label>
                <p className="text-xs text-gray-500 mt-1 mb-3" data-id="element-923">
                  OTP sent to {identifier}
                </p>
                <div className="mt-1 flex justify-between space-x-2" data-id="element-924">
                  {[1, 2, 3, 4, 5, 6].map(i => <input key={i} type="text" maxLength={1} className="w-12 h-14 text-center text-xl font-bold border border-gray-300 rounded-lg focus:ring-[#006A4E] focus:border-[#006A4E]" onChange={e => {
                if (e.target.value && i < 6) {
                  const next = e.target.nextElementSibling as HTMLInputElement;
                  if (next) next.focus();
                }
                setOtp(prev => prev + e.target.value);
              }} data-id="element-925" />)}
                </div>
              </div>

              <div data-id="element-926">
                <button type="submit" className="w-full flex justify-center py-3 px-4 border border-transparent rounded-lg shadow-sm text-sm font-medium text-white bg-[#006A4E] hover:bg-[#004D3A] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#006A4E] transition-colors" data-id="element-927">
                  {t('verifyLogin')}
                </button>
              </div>

              <div className="text-center" data-id="element-928">
                <button type="button" onClick={() => setStep(1)} className="text-sm text-[#006A4E] hover:underline font-medium" data-id="element-929">
                  Change Mobile/NID
                </button>
              </div>
            </form>}
        </div>
      </div>
    </div>;
}